import Box from '@mui/material/Box';
import Error from '../components/global/Error';
import useGetSubscription from '../hooks/subscriptions/useGetSubscription';
import PaymentMethodSection from '../components/subscriptions/PaymentMethodSection';
import PlanDetailsSection from '../components/subscriptions/PlanDetailsSection';
import BillingHistorySection from '../components/subscriptions/BillingHistorySection';
import useGetSubscriptionFromStripe from '../hooks/subscriptions/useGetSubscriptionFromStripe';
import FreeTrialAlert from '../components/subscriptions/FreeTrialAlert';
import PaymentFailedAlert from '../components/subscriptions/PaymentFailedAlert';
import PageLayout from '../components/global/PageLayout';
import { isSudoManager } from '../utils/global/helper';
import useUser from '../hooks/global/useUser';
import PageLoading from '../components/global/PageLoading';
import useOnSubscriptionRedirect from '../hooks/subscriptions/useOnSubscriptionRedirect';

export default function SubscriptionPage() {
  const { user } = useUser();

  const query = useGetSubscription();
  const stripeQuery = useGetSubscriptionFromStripe();

  const isLoading = query.isLoading || stripeQuery.isLoading;
  const isRefetching = query.isRefetching || stripeQuery.isRefetching;

  const { subscription } = query.data || {};
  const { product } = stripeQuery.data || {};

  useOnSubscriptionRedirect();

  if (query.isError || (!isLoading && (!subscription || !product))) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: 'calc(100vh - 200px)',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Error errorMessage="Error fetching subscription" />
      </Box>
    );
  }

  return (
    <main>
      <PageLayout
        title="Manage Subscription"
        isLoading={isRefetching}
        guard={{
          isAllowed:
            !!user &&
            (isSudoManager(user) || user.business.type === 'INDEPENDENT'),
        }}>
        {isLoading && <PageLoading />}
        {!isLoading && (
          <>
            <FreeTrialAlert />
            <PaymentFailedAlert />
            <PaymentMethodSection />

            {!!product && <PlanDetailsSection />}

            <BillingHistorySection />
          </>
        )}
      </PageLayout>
    </main>
  );
}
